interface ErrorMessageProps {
  error?: string;
  className?: string;
}

export const ErrorMessage = ({ error, className = '' }: ErrorMessageProps) => {
  if (!error) return null;

  return (
    <div
      className={`mb-[12px] rounded-[6px] bg-red-50 p-[12px] text-[14px] text-red-600 ${className}`}
    >
      {error}
    </div>
  );
};
